import { LoggedUser } from 'entities';

import { RoutePermissions } from './build';

interface PermissionProps {
  customPermissionCheck?: (user: LoggedUser) => boolean;
  permissions?: RoutePermissions;
}

export function shouldBlockRoute(
  { customPermissionCheck, permissions }: PermissionProps,
  user?: LoggedUser | null,
): boolean {
  if (!permissions && !customPermissionCheck) return false;

  if (!user) return true;

  if (customPermissionCheck) return !customPermissionCheck(user);

  const { countries = [] } = permissions ?? {};

  const countryBlock = !countries.includes(user.country);

  if (countryBlock) return true;

  return false;
}
